import React from 'react'
import {
    FaFacebookSquare, FaGithubSquare, FaInstagramSquare,
    FaTwitterSquare, FaEnvelope
} from 'react-icons/fa'
import { BsFillPhoneFill } from 'react-icons/bs'

const Contact = () => {
    return (
        <div>
            <div className='bg-white drop-shadow-sm rounded-md mt-8 pb-6'>
                <h3 className="card-title">All Socail Link</h3>
                <div className='px-7'>
                    <form action="">
                        <div className='grid grid-cols-2 gap-x-10'>
                            <div className='space-y-4'>
                                <div>
                                    <label htmlFor="email" className='font'>Email</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><FaEnvelope className='text-xl text-gray-500' /> </span>
                                        <input type="text" id='email' className='pl-10' placeholder='info@contact.com' />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="fb">Phone</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><BsFillPhoneFill className='text-xl text-gray-500' /> </span>
                                        <input type="text" className='pl-10' placeholder='0123456789' />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="address">Address</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><BsFillPhoneFill className='text-xl text-gray-500' /> </span>
                                        <input type="text" id='address' className='pl-10' placeholder='Madhupur, Tangail' />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="fb">Facebook</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><FaFacebookSquare className='text-xl text-gray-500' /> </span>
                                        <input type="text" className='pl-10' placeholder='https://facebook.com/john-doe' />
                                    </div>
                                </div>
                         
                            </div>
                            <div className='space-y-4'>
                                <div>
                                    <label htmlFor="fb">Twitter</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><FaTwitterSquare className='text-xl text-gray-500' /> </span>
                                        <input type="text" className='pl-10' placeholder='https://twitter.com/john-doe' />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="fb">Instragram</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><FaInstagramSquare className='text-xl text-gray-500' /> </span>
                                        <input type="text" className='pl-10' placeholder='https://Instragram.com/john-doe' />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="fb">Github</label>
                                    <div className='flex items-center gap-x-2 relative'>
                                        <span className='absolute top-[9px] left-3' ><FaGithubSquare className='text-xl text-gray-500' /> </span>
                                        <input type="text" className='pl-10' placeholder='https://github.com/john-doe' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='pt-7'>
                            <button type="submit" className=" btn text-[#444] bg-gray-300 cursor-not-allowed" disabled>Submit</button>
                            <button type="submit" className="ml-4 btn btn-danger">Save as draft</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact;